import { Routes } from '@angular/router';

export const subscriptionManagementRoutes: Routes = [
  { path: '', redirectTo: 'billing-overview', pathMatch: 'full' },
  {
    path: 'billing-overview',
    data: {
      icon: 'summarize',
      iconType: 'MAT',
      label: 'Billing Overview',
    },
    loadComponent: () =>
      import('./billing-overview/billing-overview.component').then(
        (m) => m.BillingOverviewComponent
      ),
  },
  {
    path: 'billing-history',
    data: {
      icon: 'history',
      iconType: 'MAT',
      label: 'Billing History',
    },
    loadComponent: () =>
      import('./billing-history/billing-history.component').then(
        (m) => m.BillingHistoryComponent
      ),
  },
  {
    path: 'billing-details',
    data: {
      icon: 'credit_card',
      iconType: 'MAT',
      label: 'Billing Details',
    },
    loadComponent: () =>
      import('./billing-details/billing-details.component').then(
        (m) => m.BillingDetailsComponent
      ),
  },
  {
    path: 'my-subscription',
    data: {
      icon: 'card_membership',
      iconType: 'MAT',
      label: 'My Subscription',
    },
    loadComponent: () =>
      import('./manage-subscription/manage-subscription.component').then(
        (m) => m.ManageSubscriptionComponent
      ),
  }
];
